import { render, staticRenderFns } from "./BookingEditor.vue?vue&type=template&id=f30a23fe&scoped=true"
import script from "./BookingEditor.vue?vue&type=script&lang=js"
export * from "./BookingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30a23fe",
  null
  
)

export default component.exports